import { Card } from '@/components/ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { TrainingStats } from '@/hooks/useTrainingStats';

interface ImprovementGraphProps {
  stats: TrainingStats;
}

export function ImprovementGraph({ stats }: ImprovementGraphProps) {
  const data = stats.weeklyProgress.map(week => ({
    week: new Date(week.week).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    'Success Rate': week.successRate,
    'Avg Time (s)': week.avgTime,
    attempts: week.attempts
  }));

  if (data.length === 0) {
    return (
      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Progress Over Time</h3>
        <div className="h-64 flex items-center justify-center text-muted-foreground">
          Not enough data yet. Keep training to see your progress!
        </div>
      </Card>
    );
  }

  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Progress Over Time</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
          <XAxis 
            dataKey="week" 
            className="text-xs"
            tick={{ fill: 'hsl(var(--muted-foreground))' }}
          />
          <YAxis 
            yAxisId="left"
            className="text-xs"
            tick={{ fill: 'hsl(var(--muted-foreground))' }}
            label={{ value: 'Success Rate (%)', angle: -90, position: 'insideLeft' }}
          />
          <YAxis 
            yAxisId="right"
            orientation="right"
            className="text-xs"
            tick={{ fill: 'hsl(var(--muted-foreground))' }}
            label={{ value: 'Avg Time (s)', angle: 90, position: 'insideRight' }}
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: 'hsl(var(--card))',
              border: '1px solid hsl(var(--border))',
              borderRadius: '8px'
            }}
          />
          <Legend />
          <Line 
            yAxisId="left"
            type="monotone" 
            dataKey="Success Rate" 
            stroke="hsl(var(--teen-green))" 
            strokeWidth={2}
            dot={{ fill: 'hsl(var(--teen-green))' }}
          />
          <Line 
            yAxisId="right"
            type="monotone" 
            dataKey="Avg Time (s)" 
            stroke="hsl(var(--teen-blue))" 
            strokeWidth={2}
            dot={{ fill: 'hsl(var(--teen-blue))' }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
}
